<template>
    <section class="apply-item">
        <div class="content round-corner">
          <h5 class="sender applyName" style="font-size: .37333rem;">
            {{item.FLOWNAME}}
          </h5>
          <van-tag v-for="(item, index) in tagStatus" :key="index" :color="item.color">{{item.text}}</van-tag>
<!--            <span class="applyStatus" v-if="item.FLOWSTATUS=='进行中'" v-html="item.FLOWSTATUS" style="background: rgb(4, 190, 2);"></span>
            <span v-if="item.FLOWSTATUS=='已完成'" v-html="item.FLOWSTATUS" style="background: rgb(102, 102, 102);"></span>-->
            <p>
              {{item.APPLYNAME}}发起于{{item.APPLYTIME}}
            </p>
            <div class="btn-wrap">
                <span class="btn-detail" v-if="item.ID" @click="applyDetail(item.ID)">查看详情</span>
            </div>
        </div>
    </section>
</template>

<script>
import {Button, Icon, Image, Tag} from 'vant'
    import {locationTo} from "@/utils/url";
    import {formatDateTimeToNow} from "@/utils/dateTimeUtil"

    export default {
        name: 'MessageItem',
        props: ['item'],
        components: {
          [Tag.name]: Tag,
        },
        data() {
            return {}
        },
        computed: {
          parsedDateDistance() {
            return formatDateTimeToNow(this.item.st)
          },
          tagStatus() {
            let result = {}
            switch (this.item.TSTATUS) {

              case 'end':
                result.text = '已办结'
                result.color = '#666'
                break;
              case 'send':
                result.text = '进行中'
                result.color = '#04be02'
                break;
              case 'finish':
                result.text = '已中止'
                result.color = '#4F4A81'
                break;
              case 'back':
                result.text = '已退回'
                result.color = '#ef4f4f'
                break;
              case 'draft':
                result.text = '草稿'
                result.color = '#deb887'
                break;
              case 'revoke':
              case 'haverevoke':
                result.text = '已撤销'
                result.color = '#947286'
                break;
            }
            return [result]
          },
        },
        methods: {
          applyDetail(itemId){
            this.locationTo(`weixin/weui/cooperate.html#detail/`+itemId);
          },
          locationTo
        }
    }
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
    .apply-item {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        position: relative;
        margin: 10px 12px;
    }

    .content {
        padding: 10px 15px;
        background-color: #ffffff;

        .sender-wrap {
            display: flex;
            align-items: center;
            border-radius: 2px;
            margin-bottom: 5px;

            &:active {
                background-color: lighten(#000000, 96%);
            }

            .sender {
                display: inline-block;
                color: lighten(#000000, 15%);
                font-weight: 400;
                margin-left: 5px;
            }
        }

        p {
            margin-bottom: 5px;
            line-height: 1.6;
            color: lighten(#000000, 35%);
            font-weight: 400;
            text-align: justify;
            word-break: break-all;
            @extend .font14;
            margin-top: 10px;
            color: #8c8c8c
        }

        .btn-wrap {
            text-align: right;

            .btn-detail {
                color: var(--main-color);
                padding: 3px 10px;
                margin: -5px;
                border-radius: 2px;
                @extend .font12;

                &:active {
                    background-color: lighten(#000, 96%);;
                }
            }
        }
      .applyStatus {
        padding: 1px 0.10667rem;
        color: #fff;
        font-size: .32rem;
        border-radius: 0.05333rem;
        margin-bottom: 0.26667rem;
      }
    }
</style>
